import React, { useState } from "react";
import styled from "styled-components";
import * as colors from "../../util/colors"
import Exclamation_icon_qsub from '../../assets/icons/exclamation-icon-qsub.svg';
import { DEFAULT_FONT_FAMILY } from '../../util/typography/base';
import { cancerTypes } from '../../util/data/cancerTypes';
import { indications } from '../../util/data/indications';
import IndicationDosing from "./IndicationDosing";
import FeaturedCTA from "../FeaturedCTA";
import { NotationBlock } from "../../util/typography";
import { indicationDosingContent, cancerTypeFootnotes } from './dosingContent';
import { indicationQlexMTDosingContent, cancerTypeFootnotesQsub } from './qlexMTDosingContent';
import ComponentWrapper from "../layout/ComponentWrapper";
import { NAVIGATION_BREAKPOINT } from "../../constants/layout";
import { multiTextUnderline } from "../../util/typography/Text";

const brandTabTypes = [{id:"keytruda", icon:"/static/images/icons/pill-bottle-ink-blueberry.svg", iconActive:"/static/images/icons/pill-bottle-ink.svg" , type: "Keytruda", baseColor: colors.keytrudaGreen, iconInactiveHover: '/static/images/icons/pill-bottle-ink-blueberryDark.svg'},{id:"keytruda-qlex", icon:"/static/images/icons/syringe-ink-blueberry.svg", iconActive:"/static/images/icons/syringe-white.svg", iconInactiveHover: '/static/images/icons/syringe-ink-blueberryDark.svg', type: "Keytruda Qlex", baseColor: colors.lightPurple}];

export default function IndicationBrandTab({cancerTypeId, listType}){
    const [brandTab, setBrandTab] = useState("keytruda");

    function handleUpdateBrandTab(tabName){
        setBrandTab(tabName)
    }

    const MaxWidthComponentWrapper = styled(ComponentWrapper)`
        max-width: 824px;
        margin-bottom:0;
    `;

    const IndicationButtonGroup = styled.div`
        display:flex;
        justify-content:center;
        margin-bottom: 40px;
        @media(max-width: ${NAVIGATION_BREAKPOINT}){
            margin-bottom: 30px;
        }
        
    `
    const StyledIndicationButtonGroup = styled.div`
    border-radius: 40px;
    overflow:hidden;
    display:flex;
    border: 1px solid ${colors.pebble};
    `

    const TriageListTabWrapper = styled.div`
    
     [class^="BoxedDefinitionList__ItemContainer"]{
        border: 1px solid ${colors.pebble}
        }
        
    ${brandTab === "keytruda-qlex" ? `
        [class^="Heading__H7"],
        [class^="BoxedDefinitionList__ItemTitle"] {
            background: ${colors.extraLightPurple};
        }
            [class^="BoxedDefinitionList__ItemText"] ul li::before {
        background-color: ${colors.lightPurple};
        }
        [class*="ComponentWrapper"][class*="AccordionGroup__StyledComponentWrapper"] {
        margin-bottom: 0px !important;
        }
        //    [class^="ComponentWrapper"],[class^="AccordionGroup__StyledComponentWrapper"]{
        //   margin-bottom: 0px !important;
        //   }
        [class*="ExclamationList__ItemTextContainer"] {
        &:before {
        background-image: url(${Exclamation_icon_qsub});
        }
        }
        ` : ``}
        `;

    return <TriageListTabWrapper> <IndicationButtonGroup><StyledIndicationButtonGroup>
                                        {brandTabTypes.map(eachButton => <IndcationButton key={eachButton.id} data={eachButton} isActive={brandTab === eachButton.id} updateTab={handleUpdateBrandTab} />)
                                        }
                                        </StyledIndicationButtonGroup>
                                    </IndicationButtonGroup>
                                    {
                                        cancerTypes[cancerTypeId].indications.map((indicationID, indicationIndex) => {
                    //if no indications exist for whatever reason, exit
                    if (!indicationID) return;
    
                    //build the indication display props
                    const indication  =  indications[indicationID];

                     const indicationName = (listType === 'dosing' && indication.dosingName && brandTab !== 'keytruda-qlex')
                                        ? indication.dosingName
                                        : (brandTab === 'keytruda-qlex' && indication.IVandQlexName)
                                        ? indication.IVandQlexName
                                        : indication.name;

                    // const isUsingQlexName = brandTab === 'keytruda-qlex' && indication.qlexName;
                    // const title = indication.modifier && !isUsingQlexName
                    //     ? indication.modifier + ' ' + indicationName
                    //     : indicationName;
                    const title = (brandTab === 'keytruda-qlex' && !!indication.qlexModifier?.[1]?.modifier) 
                            ? indication.qlexModifier[1].modifier + ' ' + indicationName
                            : indication.modifier 
                            ? indication.modifier + ' ' + indicationName
                            : indicationName
                   
                        const footnotesData =
                                        brandTab === "keytruda-qlex"
                                        ? cancerTypeFootnotesQsub
                                        : cancerTypeFootnotes;
                        return (
                            <>
                                {/* Exclude combination linkouts from Dosing Triage */}
                                {(!indication.isCombination) && <>                                    
                                    <IndicationDosing
                                        title={title}
                                        // body={indicationDosingContent[indicationID]}
                                        body={
                                             brandTab === "keytruda-qlex"
                                                ? indicationQlexMTDosingContent[indicationID]
                                                : indicationDosingContent[indicationID]
                                        }
                                    /> </>
                                }
                                {/* The last indication in each cancerType is followed by a FeaturedCTA */}
                                {(indicationIndex === cancerTypes[cancerTypeId].indications.length - 1) &&
                                    <MaxWidthComponentWrapper>
                                        <FeaturedCTA
                                            title="Review Dose Modifications for Adverse Reactions"
                                            ctas={[
                                                {
                                                    label: "Dose Modifications",
                                                    url: brandTab === "keytruda-qlex"
                                                        ? '/static/pdf/KEYTRUDA_QLEX_Dosing_Modification_Guide.pdf'
                                                        : '/dosing/dose-modifications',
                                                    download: false,
                                                    target:  brandTab === "keytruda-qlex" ? '_blank' : ''
                                                },

                                            ]}
                                            iconAlt=""
                                            {...( brandTab === "keytruda-qlex" ? { brandType: 'dosingQsub' } : {})}
                                        />
                                        
                                        {/* Some cancerTypes include footnotes and definitions */}
                                        
    
                                        {(footnotesData[cancerTypeId]?.footnotes || footnotesData[cancerTypeId]?.definitions) && (
                                            <NotationBlock
                                                footnotes={footnotesData[cancerTypeId]?.footnotes}
                                                definitions={footnotesData[cancerTypeId]?.definitions}
                                            />
                                        )}
                                        {/* {(cancerTypeFootnotes[cancerTypeId].footnotes
                                            || cancerTypeFootnotes[cancerTypeId].definitions) &&
                                            <NotationBlock
                                                footnotes={cancerTypeFootnotes[cancerTypeId].footnotes}
                                                definitions={cancerTypeFootnotes[cancerTypeId].definitions}
                                            />} */}
                                    </MaxWidthComponentWrapper>}
                            </>
                        )
                })
                                    }
            </TriageListTabWrapper>

}


function IndcationButton({data, updateTab, isActive}){
    const IndcationBtn = styled.button`
        display: flex;
        padding: 0 37px;
        justify-content: center;
        align-items:center;
        border:none;
        gap: 8px;
        min-width: 243px;
        width: 100%;
        height: 100%;
        min-height: 44px;
        font-family: ${DEFAULT_FONT_FAMILY};
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        cursor: pointer;
        text-transform: uppercase;
        
        > span {
            ${multiTextUnderline}
            background-image: linear-gradient(transparent, transparent), linear-gradient(${colors.blueberryDark}, ${colors.blueberryDark});
        }
        &:hover {
            > span {
                background-size: 100% 1.1px;
            }
        }

        @media(max-width: ${NAVIGATION_BREAKPOINT}){
            min-width: 50%;
            min-height: 50px;
            font-size: 14px;
            display: inline;
        }
        ${isActive ? 
            `background-color: ${data.baseColor};
            color: ${colors.ink};
            ${data.id === "keytruda-qlex" ? `color: ${colors.white};` : ``}
            span {
                background-image:  ${data.id === "keytruda-qlex" ? `linear-gradient(transparent, transparent), linear-gradient(${colors.white}, ${colors.white})` : `linear-gradient(transparent, transparent), linear-gradient(${colors.ink}, ${colors.ink})`};
            }

            &:hover {
                background-color: ${data.id === "keytruda-qlex" ? colors.darkPurple : colors.consumerGreen };
            }
            ` : 
            `background-color: ${colors.white};
            color: ${colors.blueberry};

            &:hover {
                // background-color: ${colors.mist};
                color: ${colors.blueberryDark};
                i {
                 background-image: url(${data.iconInactiveHover});
                }
            }
        
        `}  
        
    `;

    const IndcationBtnIcon = styled.i`
        width: 18px;
        height: 18px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(${isActive ? data.iconActive : data.icon});
        @media(max-width: ${NAVIGATION_BREAKPOINT}){
         display: none;
        }

    `
    return <IndcationBtn  onClick={()=> updateTab(data.id)}>{data.icon && <IndcationBtnIcon className={data.icon}></IndcationBtnIcon>}<span>{data.type}</span></IndcationBtn>
}
